// extracted by mini-css-extract-plugin
module.exports = {"configsCard":"config_configsCard__1X5vI","conutriesContainer":"config_conutriesContainer__2LhPm","country_btn":"config_country_btn__GX5AB"};